import { getListTransform } from 'helpers/transformResponse';
import types from './types';

const INITIAL_STATE = {
  list: {
    content: [],
  },
  listTemplates: {
    content: [],
  },
  detail: {},
  loading: false,
  loadingTemplates: false,
  buttonLoading: false,
  status: 'idle',
  listUsersSubscriptions: [],
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SUBSCRIBE_PRODUCT_FETCHED:
      return {
        ...state,
        list: getListTransform(action.payload.data) || INITIAL_STATE.list,
        loading: false,
      };
    case types.SUBSCRIBE_PRODUCT_DETAIL:
      return {
        ...state,
        detail: action.payload,
        loading: false,
        status: 'resolved',
      };
    case types.SUBSCRIBE_PRODUCT_LOAD:
      return {
        ...state,
        loading: action.payload,
        status: action.payload,
      };
    case types.SUBSCRIBE_PRODUCT_TEMPLATES_FETCHED:
      return {
        ...state,
        listTemplates: getListTransform(action.payload.data) || INITIAL_STATE.listTemplates,
        loadingTemplates: false,
      };
    case types.SUBSCRIBE_PRODUCT_TEMPLATES_LOAD:
      return {
        ...state,
        loadingTemplates: action.payload,
      };
    case types.SUBSCRIBE_PRODUCT_BUTTON_LOAD:
      return {
        ...state,
        buttonLoading: action.payload,
      };
    case types.USERS_SUBSCRIPTION_ACTIONS_LOAD:
      return {
        ...state,
        loading: action.payload,
      };
    case types.USERS_SUBSCRIPTION_ACTIONS_FETCHED:
      return {
        ...state,
        loading: false,
        listUsersSubscriptions: action.payload.data,
      };

    default:
      return state;
  }
};
